import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useGlobalStore } from '@dmp/stores/globalStore';

import { AppLayoutFooter } from '../_share_/AppLayoutFooter/AppLayoutFooter';
import './App.Layout.css';
import { init } from './AppLayout.utils';
import { GlobalHeader } from './GlobalHeader/GlobalHeader';
import { TenantHeader } from './TenantHeader/TenantHeader';

export const AppLayout = () => {
  const { pathname } = useLocation();
  const isTenant = useGlobalStore((s) => s.isTenant);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-[#f2f5fa] px-4">
      {isTenant ? <TenantHeader /> : <GlobalHeader />}
      <Outlet />
      <AppLayoutFooter />
    </div>
  );
};
